<template>
  <header :class="{ collapsed: menuCollapsed, white: headerWhite }">
    <div class="logos">
      <a
        href="https://www.rosatom.ru/"
        target="_blank"
        class="logo_rosatom"
      ></a>
      <a href="https://atom75.ru/" target="_blank" class="logo_rosatom75"></a>
    </div>
    <nav :class="{ show: menuIsOpen }">
      <a href="https://atom75.ru/" class data-hover>Главная</a>
      <a href="https://atom75.ru/#history" data-hover
        >История атомной промышленности</a
      >
      <a href="#" class="router-link-exact-active active" data-hover
        >История одной фотографии</a
      >
      <a href="https://calendar.atom75.ru/" target="_blank" data-hover
        >Календарь празднований</a
      >
      <a
        href="https://calendar.atom75.ru/forjournalists"
        target="_blank"
        data-hover
        >Медиакит</a
      >
      <div class="socials">
        <a
          href="https://www.facebook.com/rosatom.ru"
          data-hover
          target="_blank"
        >
          <img src="~@/assets/img/fb_w.png" class="white" />
          <img src="~@/assets/img/fb_b.png" class="blue" />
        </a>
        <a
          href="https://www.instagram.com/rosatom_ru/"
          data-hover
          target="_blank"
        >
          <img src="~@/assets/img/ig_w.png" class="white" />
          <img src="~@/assets/img/ig_b.png" class="blue" />
        </a>
        <a href="https://vk.com/rosatomru" data-hover target="_blank">
          <img src="~@/assets/img/vk_w.png" class="white" />
          <img src="~@/assets/img/vk_b.png" class="blue" />
        </a>
        <a href="https://twitter.com/rosatom/" data-hover target="_blank">
          <img src="~@/assets/img/tw_w.png" class="white" />
          <img src="~@/assets/img/tw_b.png" class="blue" />
        </a>
        <a
          href="https://www.youtube.com/user/MirnyAtom"
          data-hover
          target="_blank"
        >
          <img src="~@/assets/img/yt_w.png" class="white" />
          <img src="~@/assets/img/yt_b.png" class="blue" />
        </a>
      </div>
    </nav>
    <div
      class="burger"
      @click="toggleMenu"
      :class="{ active: menuIsOpen, hide: hideBurger }"
    >
      <svg
        data-v-a556cf7c
        preserveAspectRatio="none"
        viewBox="0 0 100 100"
        width="80"
        class="ham hamRotate ham1 active"
      >
        <path
          data-v-a556cf7c
          d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
          class="line line_top"
        />
        <path data-v-a556cf7c d="m 30,50 h 40" class="line line_middle" />
        <path
          data-v-a556cf7c
          d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656"
          class="line line_bottom"
        />
      </svg>
    </div>
  </header>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["menuIsOpen", "hideBurger", "menuCollapsed", "headerWhite"]),
  },
  methods: {
    ...mapActions(["toggleMenu"]),
  },
};
</script>

<style lang="scss">
header {
  position: relative;
  font-family: BebasNeue;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  margin: 0 auto;
  padding: 0 6.15vw;
  z-index: 100;
  pointer-events: none;
  line-height: 1;
  height: 120px;
  background: #fff;
  .logos {
    pointer-events: all;
    width: 10.5rem;
    height: 5.6rem;
    transition: 0.3s 0.2s;
    display: flex;
    a {
      display: block;
      width: 50%;
      height: 100%;
      -webkit-transition: 0.3s;
      transition: 0.3s;
    }
    .logo_rosatom {
      background: url("~@/assets/img/rosatom_logo.png") no-repeat 50% / contain;
      margin-right: 1rem;
    }
    .logo_rosatom75 {
      height: 68%;
      margin: 10px 0px 0;
      pointer-events: none;
      background: url("https://rosatom-career.ru/atom75/img/logo_75.svg")
        no-repeat 50% / contain;
    }
  }
  nav {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 85%;
    margin-top: 1.4vh;
    color: #05b;
    pointer-events: all;
    & > a {
      position: relative;
      margin-left: 3.07vw;
      font-size: 0.875rem;
      text-transform: uppercase;
      color: inherit;
      letter-spacing: 1.3px;
      &.active {
        color: #fff;
        &:before {
          content: "";
          display: block;
          position: absolute;
          top: -0.2rem;
          left: -0.7rem;
          right: -0.7rem;
          bottom: -0.15rem;
          z-index: -1;
          transform: skewX(-10deg);
          background: red;
        }
      }
    }
  }
  .socials {
    display: flex;
    margin-left: 3rem;
    a {
      position: relative;
      display: block;
      margin: 0 0.6rem;
      cursor: pointer;
      img {
        max-width: none;
      }
      img.white {
        opacity: 0;
      }
      img.blue {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .burger {
    display: none;
    position: fixed;
    top: 10vmin;
    right: 1vmin;
    pointer-events: all;
    svg {
      height: 6rem;
      width: 6rem;
      transition: transform 400ms;
      user-select: none;
    }

    path.line {
      stroke: #0055bb;
    }
    .line {
      fill: none;
      transition: stroke-dasharray 400ms, stroke-dashoffset 400ms,
        stroke 0.3s 0.3s;
      stroke: #fff;
      stroke-width: 5.5;
      stroke-linecap: round;
      &.line_top {
        stroke-dasharray: 40 139;
      }
      &.line_middle {
        stroke-dasharray: 40 180;
      }
      &.line_bottom {
        stroke-dasharray: 40 139;
      }
    }
    &.active {
      svg {
        transform: rotate(45deg);
        path {
          stroke: #fff;
        }
      }
      .line.line_top {
        stroke-dashoffset: -98px;
      }
      .line.line_bottom {
        stroke-dashoffset: -138px;
      }
    }
    &.hide {
      opacity: 0;
      pointer-events: none;
    }
  }
  &.collapsed {
    height: 90px;
    background: transparent;
    &.white {
      background: #fff;
    }
    .logos {
      position: absolute;
      top: 10%;
      left: 3.5%;
      z-index: 10000;
      width: 31vmin;
      height: 80%;
      span,
      a {
        position: relative;
        z-index: 1;
      }
    }
    nav {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      width: 100vw;
      margin: 0;
      padding: 15vh 0 5vh;
      background: url("~@/assets/img/menu_bg-mobile.jpg") no-repeat center
        center / 100% 100%;
      flex-direction: column;
      justify-content: space-around;
      transform: translate3d(-100%, 0, 0);
      opacity: 0;
      transition: 0.5s;
      &.show {
        transform: translate3d(0, 0, 0);
        opacity: 1;
      }
      a {
        color: #fff;
        font-size: 6.8vmin;
        line-height: 1;
        &.concurs {
          &:before {
            display: none;
          }
        }
      }
      & > a {
        &.active {
          &:before {
            top: -0.5rem;
            left: -0.9rem;
            right: -0.9rem;
            bottom: -0.2rem;
          }
        }
      }
    }
    .socials {
      margin-left: 0;
      a {
        margin: 0 5vmin;
        transform: scale(1.2);
        img.white {
          opacity: 1;
        }
        img.blue {
          opacity: 0;
        }
      }
    }
    .burger {
      position: absolute;
      top: 50%;
      transform: translateY(-46%);
      display: block;
      svg {
        height: 70px;
        width: 70px;
      }
    }
  }
}
.mobile header {
  background: transparent;
  &.white .logos {
    span,
    a {
      opacity: 1;
    }
  }
  .logos {
    position: fixed;
    top: 1%;
    left: 3.5%;
    z-index: 10000;
    width: 23vmin;
    height: 14vmin;
    span,
    a {
      position: relative;
      z-index: 1;
    }
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: -17vmin;
      left: -10vmin;
      right: -40vmin;
      bottom: 2vmin;
      transform: skewY(-21.6deg);
      background: #fff;
    }
  }
  .burger {
    svg {
      transition: transform 400ms;
      user-select: none;
    }
  }
}
header#portrait {
  background: transparent;
  position: fixed;
}
@media only screen and (max-width: 768px) {
  header {
    .logos .logo_rosatom75 {
      margin-top: 1.3vw;
    }
    .burger {
      &.active svg {
        transform: rotate(45deg) scale(0.8);
      }
      svg {
        transform: scale(0.8);
      }
    }
  }
}
@media only screen and (max-width: 360px) {
  header {
    .burger {
      &.active svg {
        transform: rotate(45deg) scale(0.7);
      }
      svg {
        transform: scale(0.7);
      }
    }
  }
  .mobile {
    header {
      .logos {
        width: 31vmin;
        height: 15vmin;
        &:before {
          right: -55vmin;
        }
      }
    }
  }
}
</style>